import verifyMixin from '@/mixins/verify';
import { apiThemes } from '@/apis/theme.js';
import { cloneDeep } from 'lodash';
import { handleHtmlData, optimizeRawHtmlData } from '../utils';

export default {
  mixins: [verifyMixin],
  data() {
    return {
      idTheme: '',
      loadingSave: false,
      loading: false,
      payload: {},
      sectionsHtml: '',
      footerHtml: '',
      sections: [],
      sectionsFooter: [],
    };
  },
  methods: {
    async getConfigTheme() {
      try {
        this.loading = true;
        let { data } = await apiThemes.getConfig(this.$route.params.themeId);
        this.payload = data[0] || {};
        const html = data[0]?.pages?.homepageHtml || '';
        this.sectionsHtml = html;
        this.sections = handleHtmlData(html);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async updateConfigTheme() {
      this.loadingSave = true;
      const payloadLast = cloneDeep(this.payload);

      payloadLast.pages.homepageHtml = optimizeRawHtmlData.injectCDNIfNeeded(this.sectionsHtml.trim());
      payloadLast.pages.footerHtml = optimizeRawHtmlData.injectCDNIfNeeded(this.footerHtml.trim());
      try {
        await apiThemes.updateConfig(this.idTheme, payloadLast.id, payloadLast);
        this.getTheme();
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingSave = false;
      }
    },
    async getTheme() {
      try {
        this.loading = true;
        let res = await apiThemes.get();
        let data = res.data[0];
        this.idTheme = data.id;
        let { data: dataTheme } = await apiThemes.getConfig(data.id);
        this.payload = dataTheme[0] || {};
        const bodyHtml = dataTheme[0]?.pages?.homepageHtml || '';
        const footerHtml = dataTheme[0]?.pages?.footerHtml || '';
        this.sectionsHtml = bodyHtml;
        this.footerHtml = footerHtml;
        this.sections = handleHtmlData(bodyHtml);
        this.sectionsFooter = handleHtmlData(footerHtml);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.getTheme();
  },
};
